import { Button } from "antd";
import { useIntl } from "react-intl";
import { useParams } from "react-router";
import { useUserUpdates } from "~context/UserUpdatesContext/UserUpdatesContext.tsx";
import { NotificationItemBody } from "~pages/Notifications/components/NotificationItemBody.tsx";
import { useNotificationService } from "~pages/Notifications/hooks/useNotificationService.ts";
import type { Notification } from "~types/notification.ts";

type Props = {
  notification: Notification;
};

export const PermissionChangeNotificationItem = ({ notification }: Props) => {
  const { formatMessage } = useIntl();
  const { markNotificationAsRead } = useNotificationService();
  const { refetch: refetchUserUpdates } = useUserUpdates();
  const { customerId } = useParams();

  const goToDetailsButton = (
    <Button
      type="primary"
      key="goToUserDetails"
      href={`/${customerId}/admin/${notification.data.Sport}/${notification.data.OrganizationId}/user-details`}
      style={{ textDecoration: "none" }}
      onClick={() => {
        if (notification.unread) {
          void markNotificationAsRead(notification.key);
        }
        refetchUserUpdates();
      }}
    >
      {formatMessage({ id: "button.goToUserDetails" })}
    </Button>
  );

  return <NotificationItemBody notification={notification} icon="fa-cog" customButtons={[goToDetailsButton]} />;
};
